/**
 * öl brew swipe arrows: steps the scrolling element right before <ob-swipe-arrows> by one item,
 * and hides the arrows while that element fits without scrolling.
 */
if (!customElements.get('ob-swipe-arrows')) {
  customElements.define(
    'ob-swipe-arrows',
    class extends HTMLElement {
      connectedCallback() {
        this.track = this.previousElementSibling;
        if (!this.track) return;
        this.prev = this.querySelector('[data-prev]');
        this.next = this.querySelector('[data-next]');
        this.prev.addEventListener('click', () => this.step(-1));
        this.next.addEventListener('click', () => this.step(1));
        this.update = this.update.bind(this);
        this.track.addEventListener('scroll', this.update, { passive: true });
        this.resizeObserver = new ResizeObserver(this.update);
        this.resizeObserver.observe(this.track);
        this.update();
      }

      disconnectedCallback() {
        if (this.resizeObserver) this.resizeObserver.disconnect();
      }

      step(direction) {
        const item = this.track.firstElementChild;
        const gap = parseFloat(getComputedStyle(this.track).columnGap) || 0;
        const size = item ? item.getBoundingClientRect().width + gap : this.track.clientWidth;
        this.track.scrollBy({ left: direction * size, behavior: 'smooth' });
      }

      update() {
        const { scrollLeft, scrollWidth, clientWidth } = this.track;
        const max = scrollWidth - clientWidth;
        this.hidden = max <= 2;
        this.prev.disabled = scrollLeft <= 2;
        this.next.disabled = scrollLeft >= max - 2;
      }
    }
  );
}
